import composeWrappers from './wrappers/composeWrappers';
import wrapWithIdentity from './wrappers/with-netlify-identity';
import wrapWithRedux from './wrappers/with-redux';

import './src/styles/root.scss';

export const wrapRootElement = composeWrappers(wrapWithIdentity, wrapWithRedux);
